<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">基层首诊人数</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  data() {
    return {
      config: {
        header: ['病种', '人数'],
        data: [],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        columnWidth: [350],
        align: ['left']
      }
    }
  },
  components: {},
  created() {
    let area = this.$route.query.area;
    let code = this.$route.query.code;
    let level = this.$route.query.level;
    var data = {}
    if (level == '2') {
      data = {area: area}
    } else {
      data = {code: code}
    }
    request({
      url: this.$root.api + `/api/dbz/daping/getJcszOrJkdaList/` + 'jcszrs',
      method: 'get',
      data: data
    }).then(res => {
      console.log('jcszrs---', res)
      var resdata = this.config
      resdata.data = res.data
      // resdata.data=[["三高","40"],["慢阻肺","18"],["糖尿病肾病","8"],["眩晕综合征","15"],["偏头痛","11"],["急性气管炎","3"],["慢性肺源性心脏病","2"]]
      resdata.header = ['病种', '人数']
      resdata.rowNum = 7
      resdata.headerHeight = 35
      resdata.headerBGC = '#0f1325'
      resdata.oddRowBGC = '#0f1325'
      resdata.evenRowBGC = '#171c33'
      resdata.columnWidth = [350]
      resdata.align = ['left']
      this.config = { ...resdata }
      console.log('jcszrs---', resdata)
    })
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: 500px;
  width: 100%;
  border-radius: 5px;

  .bg-color-black {
    height: 480px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;

    .dv-scr-board {
      width: 100%;
      height: 430px;
    }
  }
  ::v-deep.dv-scroll-board .rows .ceil {
    padding: 0 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: visible;
    text-overflow: ellipsis;
  }
  ::v-deep.dv-scroll-board .header .header-item {
    padding: 0 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: visible;
    text-overflow: ellipsis;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
}
</style>
